import { useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import SyncIcon from '@mui/icons-material/Sync';
import DoneIcon from '@mui/icons-material/Done';
import styled from '@emotion/styled';
import { useMutation } from 'react-query';
import { syncCoinMarketCap } from 'src/Api/cryptos';
import { toast } from 'react-toastify';
import { useInterval } from 'src/Common';
import { Tooltip } from '@mui/material';

enum SyncState {
  IDLE = 'idle',
  SUCCESS = 'success',
  ERROR = 'error'
}

const { IDLE, ERROR, SUCCESS } = SyncState;

export const ReloadPairs = () => {
  const [state, setState] = useState<SyncState>(IDLE);

  const { mutateAsync, isLoading } = useMutation(() => {
    return syncCoinMarketCap()
      .then(() => {
        toast('Sync started - this may take a few minutes', {
          theme: 'dark',
          type: 'info',
          autoClose: 5000,
          pauseOnFocusLoss: false
        });
        setState(SUCCESS);
      })
      .catch((error) => {
        toast(`Sync Error: ${error?.message}`, {
          theme: 'dark',
          type: 'error',
          autoClose: 8000,
          pauseOnFocusLoss: false
        });
        setState(ERROR);
      });
  });

  useInterval(
    () => {
      setState(IDLE);
    },
    state !== IDLE ? 10000 : null
  );

  const getProps = () => {
    const byState = {
      [IDLE]: {
        startIcon: <SyncIcon />,
        color: 'primary' as const,
        variant: 'outlined' as const
      },
      [ERROR]: {
        startIcon: <SyncIcon />,
        color: 'error' as const,
        variant: 'contained' as const
      },
      [SUCCESS]: {
        startIcon: <DoneIcon />,
        color: 'success' as const,
        variant: 'contained' as const
      }
    };

    return byState[state];
  };

  return (
    <Tooltip title="Sync cryptos from CoinMarketCap">
      <SyncButtonStyled
        loading={isLoading}
        size="small"
        loadingPosition="start"
        {...getProps()}
        onClick={() => mutateAsync()}
      >
        Sync Pairs
      </SyncButtonStyled>
    </Tooltip>
  );
};

const SyncButtonStyled = styled(LoadingButton)((props: any) => ({
  borderRadius: '20rem',
  padding: '0.2rem 1rem 0.2rem 1rem',
  color: 'white',
  borderColor: props.theme.palette.grey[600],
  borderWidth: '0.5px',
  fontSize: '.6rem',
  whiteSpace: 'nowrap'
}));

